<div id="entire-container" class="entire-container">
  <div id="registration-frame-container">
    <h1 class="register welcome">
      {{ 'REGISTRATION.WELCOME-TEXT' | translate }}
    </h1>

    <div id="registration">
      <div id="registration-frame">
        <div class="registration-container container-blue-open">
          <form #carrierProfileForm="ngForm">
            <div class="row">
              <div class="col-lg-6">
                <div class="col">
                  <label class="title-group">{{
                    'CARRIER-PROFILE.CARRIER-DETAILS' | translate
                  }}</label>
                  <div class="control-group">
                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{ 'CARRIER-PROFILE.COMPANY-NAME' | translate }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="1"
                            maxlength="100"
                            minLength="1"
                            name="company"
                            id="company"
                            [(ngModel)]="registerModel.company"
                            #Company="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            min
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{ 'CARRIER-PROFILE.STREET-NR' | translate }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="2"
                            maxlength="100"
                            minLength="1"
                            name="street"
                            id="street"
                            [(ngModel)]="registerModel.street"
                            #StreetAndNr="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{ 'CARRIER-PROFILE.ZIP-CODE' | translate }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="3"
                            maxlength="50"
                            minLength="1"
                            name="zipcode"
                            id="zipcode"
                            [(ngModel)]="registerModel.zipCode"
                            #ZipCode="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{ 'CARRIER-PROFILE.CITY' | translate }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="4"
                            maxlength="50"
                            minLength="1"
                            name="city"
                            id="city"
                            [(ngModel)]="registerModel.city"
                            #City="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{ 'CARRIER-PROFILE.COUNTRY' | translate }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="5"
                            maxlength="50"
                            minLength="1"
                            name="country"
                            id="country"
                            [(ngModel)]="registerModel.country"
                            #Country="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="col">
                  <label class="title-group">{{
                    'CARRIER-PROFILE.CONTACT-DETAILS' | translate
                  }}</label>
                  <div class="row">
                    <div class="col-md-6 col-lg-12">
                      <div class="control-group">
                        <div class="control display-control">
                          <label
                            class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                          >
                            {{
                              'CARRIER-PROFILE.CONTACT-NAME' | translate
                            }}</label
                          >
                          <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                            <div class="col-12 col-xl-4">
                              <input
                                tabindex="{{
                                  this.displayAsColumns ? '9' : '6'
                                }}"
                                maxlength="100"
                                minLength="1"
                                id="contact"
                                name="contact"
                                [(ngModel)]="registerModel.contactPerson"
                                #ContactPerson="ngModel"
                                class="input register contact-details input-cp-control"
                                type="text"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div class="control display-control">
                          <label
                            class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                          >
                            {{
                              'CARRIER-PROFILE.PHONE-NUMBER' | translate
                            }}</label
                          >
                          <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                            <div class="col-12 col-xl-4">
                              <input
                                tabindex="{{
                                  this.displayAsColumns ? '10' : '7'
                                }}"
                                maxlength="50"
                                minLength="1"
                                id="phone"
                                name="phone"
                                [(ngModel)]="registerModel.phoneNumber"
                                #PhoneNumber="ngModel"
                                class="input register contact-details input-cp-control"
                                type="text"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div class="control display-control">
                          <label
                            class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                          >
                            {{
                              'CARRIER-PROFILE.MOBILE-PHONE-NUMBER' | translate
                            }}</label
                          >
                          <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                            <div class="col-12 col-xl-4">
                              <input
                                tabindex="{{
                                  this.displayAsColumns ? '11' : '8'
                                }}"
                                maxlength="50"
                                minLength="1"
                                id="mobile"
                                name="mobile"
                                [(ngModel)]="registerModel.mobilePhoneNumber"
                                #MobilePhoneNumber="ngModel"
                                class="input register contact-details input-cp-control"
                                type="text"
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-12">
                      <div class="control-group contact-column-2">
                        <div class="control display-control">
                          <label
                            class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                          >
                            {{
                              'CARRIER-PROFILE.FAX-NUMBER' | translate
                            }}</label
                          >
                          <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                            <div class="col-12 col-xl-4">
                              <input
                                tabindex="{{
                                  this.displayAsColumns ? '12' : '9'
                                }}"
                                maxlength="50"
                                minLength="1"
                                id="fax"
                                name="fax"
                                [(ngModel)]="registerModel.faxNumber"
                                #FaxNumber="ngModel"
                                class="input register contact-details input-cp-control"
                                type="text"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        <div class="control display-control">
                          <label
                            class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                          >
                            {{
                              'CARRIER-PROFILE.EMAIL-ADDRESS' | translate
                            }}</label
                          >
                          <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                            <div class="col-12 col-xl-4">
                              <input
                                tabindex="{{
                                  this.displayAsColumns ? '13' : '10'
                                }}"
                                maxlength="100"
                                minLength="1"
                                name="email"
                                id="email"
                                placeholder="youremail@company.com"
                                [(ngModel)]="registerModel.email"
                                (input)="clearEmailError()"
                                (focusout)="validateEmail(Email.control)"
                                #Email="ngModel"
                                class="input register contact-details input-cp-control"
                                [pattern]="emailRegex"
                                type="email"
                                required
                              />
                              <div
                                class="error-message input-cp-control email-error"
                                *ngIf="emailIsUsed && submitted"
                              >
                                {{
                                  'REGISTRATION.EMAIL-EXISTS-ERROR' | translate
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="control display-control">
                          <label
                            class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                          >
                            {{ 'CARRIER-PROFILE.WEB-SITE' | translate }}</label
                          >
                          <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                            <div class="col-12 col-xl-4">
                              <input
                                tabindex="{{
                                  this.displayAsColumns ? '14' : '11'
                                }}"
                                id="website"
                                pattern="^(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,4}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&amp;?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?$"
                                maxlength="50"
                                minLength="1"
                                placeholder="www.yourwebsite.com"
                                name="website"
                                [(ngModel)]="registerModel.website"
                                #Website="ngModel"
                                class="input register contact-details input-cp-control"
                                type="url"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 group-3">
                <div class="col">
                  <label class="title-group">{{
                    'CARRIER-PROFILE.LEGAL-INFORMATION' | translate
                  }}</label>
                  <div class="control-group">
                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{ 'CARRIER-PROFILE.VAT-NUMBER' | translate }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="{{ this.displayAsColumns ? '6' : '12' }}"
                            maxlength="50"
                            minLength="1"
                            id="vat"
                            name="vat"
                            [(ngModel)]="registerModel.vatNumber"
                            appAlphaNumericDirective
                            appToUpperCase
                            #VatNumber="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            (input)="validateVatNumber()"
                            (paste)="onVatPaste($event)"
                            required
                          />
                          <div
                            class="error-message vat-error-message input-cp-control"
                            *ngIf="vatHasInvalidCharacters"
                          >
                            {{
                              'REGISTRATION.VAT-INVALID-CHARACTERS-ERROR'
                                | translate
                            }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{
                          'CARRIER-PROFILE.CHAMBER-OF-COMMERCE' | translate
                        }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="{{ this.displayAsColumns ? '7' : '13' }}"
                            maxlength="50"
                            minLength="1"
                            id="coc"
                            name="coc"
                            [(ngModel)]="registerModel.chamberOfCommerce"
                            #ChamberOfCommerce="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <label class="title-group">{{
                    'CARRIER-PROFILE.USER-DETAILS' | translate
                  }}</label>
                  <div class="control-group">
                    <div class="control display-control">
                      <label
                        class="mobile-font-size-details-on-blue desktop-font-size mobile-elem label-text"
                      >
                        {{ 'CARRIER-PROFILE.USERNAME' | translate }}</label
                      >
                      <div class="col-12 col-xl-8 offset-xl-0 offset-12">
                        <div class="col-12 col-xl-4">
                          <input
                            tabindex="{{ this.displayAsColumns ? '8' : '14' }}"
                            maxlength="50"
                            minLength="1"
                            id="username"
                            (input)="clearUsernameError()"
                            (focusout)="validateUsername(Username.control)"
                            name="username"
                            [(ngModel)]="registerModel.username"
                            #Username="ngModel"
                            class="input register input-cp-control"
                            type="text"
                            required
                          />
                          <div
                            class="error-message input-cp-control username-error"
                            *ngIf="usernameIsUsed && submitted"
                          >
                            {{
                              'REGISTRATION.USERNAME-EXISTS-ERROR' | translate
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col agree-check">
                <hr />
                <div class="col-lg-6 control display-control">
                  <div class="checkboxFive">
                    <input
                      tabindex="15"
                      id="agreement"
                      name="agreement"
                      [(ngModel)]="registrationAgreementStatus"
                      #CarrierAgreement="ngModel"
                      type="checkbox"
                      value="1"
                      id="checkboxFiveInput"
                      style="vertical-align: middle"
                    />
                    <label
                      id="rememberCheckbox"
                      class="form-check-label"
                      for="checkboxFiveInput"
                    ></label>
                    <span
                      class="label-text sentens label-checkbox"
                      style="vertical-align: middle"
                    >
                      {{ 'REGISTRATION.AGREEMENT-TEXT' | translate }}
                      <a
                        class="gtc"
                        [href]="termsAndConditions"
                        target="_blank"
                        [style.pointer-events]="
                          termsAndConditions ? 'auto' : 'none'
                        "
                        [style.color]="termsAndConditions ? '' : 'gray'"
                        >{{
                          'REGISTRATION.TERMS-AND-CONDITIONS' | translate
                        }}</a
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="error-text error-container">
              <p
                class="error-message"
                *ngIf="!registrationAgreementStatus && submitted"
              >
                {{ 'REGISTRATION.AGREEMENT-NOT-CHECKED' | translate }}
              </p>
              <p
                class="error-message"
                *ngIf="!carrierProfileForm.valid && submitted"
              >
                {{ 'ORDER-LIST-DETAILS.ERROR-FIELDS-INVALID' | translate }}
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="buttons register-buttons">
      <a [routerLink]="['/login']" class="fontTextBold register back-link">{{
        'REGISTRATION.BACK-TO-LOGIN' | translate
      }}</a>
      <button
        appDisableControl
        [disableControl]="submitted && carrierProfileForm.valid && !errors"
        class="btn btn-primary btn-large loading-button submit-btn"
        (click)="onRegister()"
      >
        {{ 'REGISTRATION.SUBMIT-TEXT' | translate }}
      </button>
    </div>
  </div>
</div>
